import { type Commands } from '../../../core/context/commands';
import { UUID } from '../../../core/context/uuid/entity';
import { ThreatVectorMitigations } from './repository';
import { ThreatVectorMitigation } from './entity';
import { type ThreatVectorMitigationData } from './dto';

export class ThreatVectorMitigationsCommands
    implements
        Commands<
            ThreatVectorMitigations,
            ThreatVectorMitigation,
            ThreatVectorMitigationData
        >
{
    addAll(
        repo: ThreatVectorMitigations,
        data: ThreatVectorMitigationData[],
    ): ThreatVectorMitigations {
        data.forEach((threatVectorMitigationData) => {
            this.add(repo, threatVectorMitigationData);
        });
        return repo;
    }

    add(
        repo: ThreatVectorMitigations,
        data: ThreatVectorMitigationData,
    ): ThreatVectorMitigations {
        const threatVectorMitigation = new ThreatVectorMitigation({
            ...data,
        });
        repo.add(threatVectorMitigation);
        return repo;
    }

    update(
        repo: ThreatVectorMitigations,
        entity: ThreatVectorMitigation,
    ): ThreatVectorMitigation {
        repo.update(entity);
        return entity;
    }

    remove(repo: ThreatVectorMitigations, id: string): void {
        repo.remove(id);
    }

    create(
        repo: ThreatVectorMitigations,
        data: Omit<ThreatVectorMitigationData, 'id'>,
    ): ThreatVectorMitigation {
        const uuid = new UUID();
        const threatVectorMitigation = new ThreatVectorMitigation({
            id: uuid.toString(),
            ...data,
        });
        repo.add(threatVectorMitigation);
        return threatVectorMitigation;
    }

    fromJSON(
        entity: ThreatVectorMitigation[],
        changeCallback: () => void,
    ): ThreatVectorMitigations {
        const newThreatVectorMitigations = new ThreatVectorMitigations(
            changeCallback,
        );
        entity.forEach((threatVectorMitigation) => {
            newThreatVectorMitigations.add(
                new ThreatVectorMitigation({
                    ...threatVectorMitigation,
                }),
            );
        });
        return newThreatVectorMitigations;
    }
}
